import { FamlyTheme as FamlyMFTheme } from '@famly/mf_theme';
import { NewColors } from 'web-app/styleguide/colors';
import { hexToRGBA } from 'web-app/util/hex-to-rgb';
import BaseTheme from './base';
const FamlyPrimary = '#5C34A3';
const FamlyChromeColor = '#4E169C';
const FamlyActive = '#906CD0';
const FamlyBackgroundHover = hexToRGBA(FamlyPrimary, 0.04);
const FamlyTheme = {
    ...BaseTheme,
    applicationBackground: '#FDFDFE',
    title: 'NewLook',
    chromeColor: FamlyChromeColor,
    primary: FamlyPrimary,
    active: FamlyActive,
    backgroundHover: FamlyBackgroundHover,
    navigationConfiguration: {
        contextualSidebarBackground: '#faf9fa',
        contextualSidebarLinkBackground: NewColors.Primary.t90,
        contextualSidebarLinkColor: NewColors.Neutral.s80,
        contextualSidebarLinkColorActive: NewColors.Analogue1.base,
    },
    mf: FamlyMFTheme,
};
export default FamlyTheme;
